import { render, staticRenderFns } from "./moreActs.vue?vue&type=template&id=6ffdc7bd&scoped=true&"
import script from "./moreActs.vue?vue&type=script&lang=js&"
export * from "./moreActs.vue?vue&type=script&lang=js&"
import style0 from "./moreActs.vue?vue&type=style&index=0&id=6ffdc7bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdc7bd",
  null
  
)

export default component.exports